import React, { useEffect, useState } from "react";
import moment from "moment";
import Search from "../../../../components/search";
import { useSelector } from "react-redux";
import Pagination from "../../../../components/tablePagination";
import { session_id_beg, session_id_end } from "../../../../utils/helpers";

import { CancelledHeaders, filterList } from "../data";
import Button from "../../../../components/button";
export default function Cancelled(props) {
  const {
    canceledAppointment,
    filterListAppointments,
    getPaginationData,
    filterReset,
    setFilterValues,
    setSearchValues,
    searchValue,
    filterValues,
    blockUser,
    setBlink,
    refundingCall,
    stopPaymentCall
  } = props;
  // const copyMeetingLink = (url) => {
  //   navigator.clipboard.writeText(url);
  // };
  const { allCancelledCount } = useSelector((state) => state.medium);
  useEffect(() => {
    setBlink(false)
  }, [])
  const handleNoShow = (e, appoinment) => {
    let value = e.target.value;
    if(value === "refund"){
      refundingCall(appoinment.medium_id, appoinment.id);
      return;
    }
  }
  const checkAppId = (appoinment) => {
    if (appoinment.is_group_session === 0) {
      return appoinment.id
    }
    else if (appoinment.is_group_session === 1) {
      // if (appoinment.attendees == undefined) {
      if (appoinment.parent_id == null) {
        return appoinment.id
      }
      else {
        return appoinment.parent_id
      }

      // }


    }
    else {
      return appoinment.id
    }

  }
  return (
    <>

      <div className="table-box-medium admin-appoi" style={{ overflow: "visible" }}>
        <div className="appt-table-scroll" style={{ overflowX: "scroll", width: "100%" }}>
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              {React.Children.toArray(
                CancelledHeaders.map((item) => <th>{item.title}</th>)
              )}

              {/* <input type="checkbox" id="one" />
                <label htmlFor="one"></label> */}
            </tr>
            {canceledAppointment.length > 0 ? (
              canceledAppointment.map((appoinment) => (
                <tr className={`innr ${appoinment.is_worker_appointment == 1 ? "isWorkedBG" : "" }`}>
                  <td>{session_id_beg + checkAppId(appoinment) + session_id_end}{appoinment.is_replaced === 1 ? <img className="ml-1 star-app-hightlight" src="../images/blackstar.jpeg" /> : ''}</td>
                  <td>
                    <span className="capitalize">{appoinment.client_name},</span>
                    <br />
                    <span className="capitalize">{appoinment.medium_name}</span>
                  </td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.date.split(" ")[0]}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>{appoinment.time}</div>
                  </td>
                  <td style={{ whiteSpace: "normal", wordBreak: "break-word", minWidth: 160, maxWidth: 220 }}>{appoinment.session_name}</td>
                  <td>
                    {appoinment.modifiedDate}
                  </td>
                  <td className="position-relative ">
                    {appoinment.session_type === "1" && <span className="block-tooltip-wrap"> <Button
                      status={0}
                      onClick={(e) => blockUser(appoinment.id, appoinment.medium_id, appoinment.client_id)}
                      type="button"
                      className={`resend-btn w-130 tooltip-2-focus`}
                      title={parseInt(appoinment.is_blocked) === 0 ? "Block" : "Unblock"}
                    />
                      <p className="tooltip-2 block-tooltip-app">{parseInt(appoinment.is_blocked) === 0 ? 'Only click if you do not want to work with this person at all.' : 'Only click if you want to work this person.'}

                      </p>
                    </span>
                    }
                  </td>
                  <td>{appoinment.userby}</td>
                   <td>{appoinment.reason}</td>
                   <td>
                    {appoinment.attendees == undefined && appoinment.subsession_table_id != 102 ?

                      <div className={`${appoinment.payment_status != null ? "color-d5a67b" : ""} d-flex align-items-center height-45`}>
                        {appoinment.payment_status != null && appoinment.payment_status != "NULL" ? (appoinment.payment_status) : 'N/A'}
                      </div>
                      :
                      'N/A'
                    }
                  </td>
                    <td>
                                       {appoinment.attendees == undefined ?
                                         <>
                                           {appoinment.is_group_session === 0 && (appoinment.session_type === "8" || appoinment.session_type === "7" || appoinment.is_extra_services == 1) ?
                                             <select
                                               // value={appoinment.statusValue}
                                               onChange={(e) => handleNoShow(e, appoinment)}
                                               className="appointment-select-box"
                                             >
                                               <option value="" selected disabled>
                                                 Select
                                               </option>
                   
                                              
                                               {((appoinment.session_type === "8" || appoinment.is_extra_services == 1) && appoinment.payment_status != "Refunding") && (
                                                 <>
                                                 <option value={"refund"}>{"Refunding"}</option>
                                                 </>
                                               )}
                                              
                   
                   
                                               
                                              
                                             </select>
                                             :
                                             'N/A'
                                           }
                                         </>
                                         :
                   
                                         "N/A"
                                       }
                                     </td>
                  {/* <td>
                    <div>
                      <p className="d-flex">
                        <div> Client:</div>{" "}
                        <div className="d5a67b ml-1">
                          {appoinment.client_email}{" "}
                        </div>
                      </p>
                      <p className="d-flex">
                        {" "}
                        <div>Medium:</div>{" "}
                        <div className="d5a67b ml-1">
                          {appoinment.medium_email}
                        </div>
                      </p>
                    </div>
                  </td> */}
                  {/* <td>Practice - 60 Min (30 Min each)</td> */}
                  {/* <td className="googl-link">
                    <a
                      className="appointment-links"
                      href={appoinment.meeting_link}
                      target="_blank"
                    >
                      {appoinment.meeting_link}
                    </a>
                    <img
                      onClick={() => copyMeetingLink(appoinment.meeting_link)}
                      className="googl-link-copy-img "
                      alt="copy"
                      src="images/copy.png"
                    />
                  </td> */}
                  {/* <td className="change">
                    <a href="#">
                      <img src="../images/email-blu.png" />
                      Email
                    </a>
                  </td> */}
                  {/* <td className="dot-image">
                    <img src="../images/Unionblck.png" />
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={20} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No Appointments Found</p>
                  </div>
                </td>
              </tr>
            )}
            {/* <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr>
            <tr className="innr">
              <td>
                <input type="checkbox" id="two" />
                <label htmlFor="two"></label>
                <span>Devid Smith</span>
              </td>
              <td>May 01 2022</td>
              <td>12:30 PM</td>
              <td>Practice - 60 Min (30 Min each)</td>
              <td>
                <a href="#">
                  meet.google.com/ict-bdvp-ydv
                  <img src="../images/copy.png" />
                </a>
              </td>
              <td className="change">
                <a href="#">
                  <img src="../images/email-blu.png" />
                  Email
                </a>
              </td>
              <td className="dot-image">
                <img src="../images/Unionblck.png" />
              </td>
            </tr> */}
          </tbody>
        </table>
                </div>
        <Pagination
          rowsPerPageOptions={[5, 10, 25]}
          count={allCancelledCount}
          getPaginationData={getPaginationData}
          activeTab={"mediumcancelled"}
        />
      </div>
    </>
  );
}
